import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-work-detail',
  templateUrl: './page-work-detail.component.html',
  styleUrls: ['./page-work-detail.component.css']
})
export class PageWorkDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
